export const temperaturesTreater = ({ minC, maxC, minF, maxF }) => ({
  tempMin: minC,
  tempMax: maxC,
  tempMinF: minF,
  tempMaxF: maxF,
});
